import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { setting } from '../../../../setting';
import { RestService } from 'app/shared/rest.service';

@Injectable({
  providedIn: 'root'
})
export class RequestBilledFormService {

  constructor(private _http: HttpClient, private _restService: RestService) { }

  // Abaco se consulta vía el proxy de Booking (las credenciales las agrega el backend).
  private getAbaco(path: string): Observable<any> {
    return this._http.get<any>(`${setting.apiBookingUrl}abaco/${path}`);
  }


  getTypeIva(): Observable<any> {
    return this.getAbaco('ivaConditions');
  }

  getConditionIva(): Observable<any> {
    return this.getAbaco('arca/catalogs/getReceiverIVACondition');
  }

  getCurrencies(): Observable<any> {
    return this.getAbaco('arca/catalogs/getTiposMonedas');
  }

  getIvaTypes(): Observable<any> {
    return this.getAbaco('arca/catalogs/getTiposIVA');
  }

  getTourismItems(): Observable<any> {
    return this.getAbaco('arca/wsct/catalogs/codigos-item-turismo');
  }

  getEnterprise(): Observable<any> {
    return this.getAbaco('enterprises');
  }

  getDocType(): Observable<any> {
    return this.getAbaco('arca/catalogs/getTiposDocumentos');
  }

  getReceiptType(): Observable<any> {
    return this.getAbaco('arca/catalogs/getTiposComprobantes');
  }

  getConceptType(): Observable<any> {
    return this.getAbaco('arca/catalogs/getTiposConcepto');
  }

  countriesInvoiceT(): Observable<any> {
        return this.getAbaco('arca/wsct/catalogs/paises');
  }

  getDoctTypeBookingList(): Observable<any> {

    return this._restService.doGet('app', 'documentTypes');
  }

  getClients(): Observable<any> {

    return this._restService.doGet('app', 'clientsAllBilled');

  }

  getCountriesApi(): Observable<any> {

    return this._restService.doGet('app', 'utilities/countries');

  }

  getDestinationsApi(country: string): Observable<any> {

    return this._restService.doGet('app', `utilities/destinations/${country}`);

  }

  getCitiesApi(destination: number): Observable<any> {

    return this._restService.doGet('app', `utilities/cities/${destination}`);

  }
}
